import React from 'react';

import {
    Banner,
    Button, CellButton,
    Div,
    Group,
    MiniInfoCell,
    ModalPage,
    ModalPageHeader, ModalRoot,
    PanelHeaderButton,
    SplitCol,
    SplitLayout
} from '@vkontakte/vkui';
import {instanceOf} from 'prop-types';

import {
    Icon20Info,
    Icon28FolderOutline,
    Icon28ShoppingCartOutline,
    Icon28Video,
    Icon16TruckOutline,
    Icon20SunOutline,
    Icon20MoonOutline,
    Icon20QuestionOutline,
    Icon24Cancel,
    Icon20Search,
    Icon28WindowCheck,
    Icon20PhoneOutline,
    Icon20MailOutline,
    Icon20FolderMoveOutline,
    Icon20PinDotOutline,
    Icon20Clear,
    Icon28WrenchOutline
} from "@vkontakte/icons";
import {withCookies, Cookies} from 'react-cookie';
import {AdaptivityContext, EMPTY_LINK, checkCanViewCatalog, checkCanViewOst2, canUseProductSearch} from "./assets/constants";
import CartApi from "./api/CartApi";
import * as constants from "./assets/constants";

import {current_theme} from "./index";
import NewsList from "./news/newsList";
import SendHelpForm from "./api/SendHelpForm";
import Autocomplete from "./assets/autocomplete";
import MallSmartAutocomplete from "./salePointsMonitoring/mallSmartAutocomplete";
import HelpButton from "./assets/HelpButton";
import ProductsSmartAutocomplete from "./catalog/productsSmartAutocomplete";


class Default extends React.Component {

    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props) {
        super(props);
        const {cookies} = props;
        const day = new Date().getDate()
        let daysLeft = 0

        if (day < 25) {
            daysLeft = 25 - day
        }

        this.state = {
            searchHistory: [],
            activeModal: null,
            modalHistory: [],
            name: cookies.get('reactcatalog') || '0',
            daysLeft: daysLeft
        };
        const searchHistory = JSON.parse(localStorage.getItem(constants.search_history_key))

        if (searchHistory && Array.isArray(searchHistory)) {
            const items = []

            searchHistory.reverse().map((el) => items.push({
                label: el,
                value: el
            }))


            this.state.searchHistory = items
        }
        this.modalBack = () => {
            this.setActiveModal(this.state.modalHistory[this.state.modalHistory.length - 2]);
        };

    }

    setActiveModal(activeModal) {
        activeModal = activeModal || null;
        let modalHistory = this.state.modalHistory ? [...this.state.modalHistory] : [];

        if (activeModal === null) {
            modalHistory = [];
        } else if (modalHistory.indexOf(activeModal) !== -1) {
            modalHistory = modalHistory.splice(0, modalHistory.indexOf(activeModal) + 1);
        } else {
            modalHistory.push(activeModal);
        }

        this.setState({
            activeModal,
            modalHistory
        });
    };

    searchTimeout = null

    goSearch = () => {
        clearTimeout(this.searchTimeout)

        if (this.state.search) {
            const hideOst = this.props.current_user.meta.settings
                && this.props.current_user.meta.settings.hide_ost == '1'
            const canViewCatalog = checkCanViewCatalog(this.props.current_user)
            const canViewOst2 = checkCanViewOst2(this.props.current_user)
            if (canViewCatalog && !hideOst) {
                window.location.href = `/ostatki/?search=${this.state.search}`
            } else if (canViewOst2) {
                window.location.href = `/ostatki2/?search=${this.state.search}`
            }
        }
    }
    setSearch = (label) => {
        clearTimeout(this.searchTimeout)
        this.setState({search: label})

        this.searchTimeout = setTimeout(() => {
            clearTimeout(this.searchTimeout)
            this.goSearch()
        }, 2500)

    }

    render() {


        const main_modals =
            <ModalRoot activeModal={this.state.activeModal}>


                <ModalPage hideCloseButton={true}
                           id={constants.MODAL_LIST_OBJECTS}
                           onClose={this.modalBack}
                           settlingHeight={100}

                           header={
                               <ModalPageHeader
                                   after={<PanelHeaderButton
                                       onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                               >
                                   Обращение в тех. поддержку Scladro
                               </ModalPageHeader>
                           }
                >
                    <SendHelpForm goBack={() => this.setActiveModal(null)}
                                  base_url={this.props.base_url}/>
                </ModalPage>
            </ModalRoot>;
        const current_user = this.props.current_user
        const techBanner = String(
            current_user && current_user.tech_banner_enabled == '1' ? (current_user.tech_banner || '') : ''
        ).trim()
        const showTechBanner = techBanner && techBanner !== '#####'

        return (current_user &&
            <SplitLayout modal={main_modals}>
                <SplitCol>
                    <Group className="main-element">
                        {showTechBanner &&
                            <Div>
                                <Banner
                                    mode="tint"
                                    before={<Icon28WrenchOutline/>}
                                    text={<span style={{whiteSpace: 'pre-wrap'}}>{techBanner}</span>}
                                />
                            </Div>}

                        <Div className="main-page-greeting">
                            <h1>Добро пожаловать, {current_user.name}!</h1>
                        </Div>
                        {canUseProductSearch(current_user) &&
                            <div key="goSearch"
                                 className={'main-page ' + (AdaptivityContext.isMobile ? 'mobile' : 'desktop')}>
                                <form onSubmit={(e) => {
                                    e.preventDefault()
                                    this.goSearch()
                                }}>
                                    <Autocomplete
                                        value={this.state.search}
                                        items={this.state.searchHistory}
                                        after={<Button mode="outline" size="l"
                                                       onClick={() => this.goSearch()}

                                        ><Icon20Search/></Button>}
                                        type="search"
                                        name="search_1234"
                                        onChange={label => this.setSearch(label)}
                                        style={{width: AdaptivityContext.isMobile ? '311px' : '622px', clear: 'both'}}
                                        placeholder="Что ищем?"/>
                                </form>

                            </div>
                        }
                        <div key="goCatalogButtons"
                             className={'main-page ' + (AdaptivityContext.isMobile ? 'mobile' : 'desktop')}>

                            {this.props.clubs && this.props.clubs.length > 0 &&
                                <div className="main-page-button" href="#" data-story="clubs_story"
                                     onClick={(event) => {
                                         event.preventDefault();
                                         this.props.changeStory(event)
                                     }}>
                                    <Icon28FolderOutline width={60} height={60}/>
                                    <p className="main-page-button_text">Эксклюзивные программы</p>
                                </div>}
                            {(current_user && current_user.address_program == '1' && current_user.position) &&

                                <div className="main-page-button" href="#" data-story="references_story"
                                     onClick={(event) => {
                                         event.preventDefault();
                                         this.props.changeStory(event)
                                     }}>
                                    <Icon20PinDotOutline width={60} height={60}/>
                                    <p className="main-page-button_text"> Адресная программа</p>
                                </div>
                            }
                            {!(current_user.meta.settings && current_user.meta.settings.hide_ost == '1')
                                && checkCanViewCatalog(current_user) &&
                                <div className="main-page-button" href="#" data-story="ostatki_story"
                                     onClick={(event) => {
                                         event.preventDefault();
                                         this.props.changeStory(event)
                                     }}>
                                    <Icon28FolderOutline width={60} height={60}/>
                                    <p className="main-page-button_text">Каталог</p>
                                </div>}

                            <div key="goCart" className="main-page-button orange" href="#" data-story="cart_story"
                                 onClick={(event) => {
                                     event.preventDefault();
                                     this.props.changeStory(event)
                                 }}>
                                <Icon28ShoppingCartOutline width={60} height={60}/>
                                <p className="main-page-button_text">Корзина</p>
                                <div className="main-page-button_cart-counter">{CartApi.items.length}</div>
                            </div>
                            {current_user.isRetail &&
                                <div key="goMonitoring" className="main-page-button orange" href="#"
                                     data-story="monitoring_story" onClick={(event) => {
                                    event.preventDefault();
                                    this.props.changeStory(event)
                                }}>
                                    <Icon28Video width={60} height={60}/>
                                    <p className="main-page-button_text" style={{fontSize: '16px'}}>Мониторинг</p>
                                    <div className="main-page-button_cart-counter">{this.state.daysLeft}</div>
                                </div>}
                            {current_user['meta']['rules'] && current_user['meta']['rules']['admin'] &&
                                <div key="goIncoming" className="main-page-button orange" href="#"
                                     data-story="incoming_story" onClick={(event) => {
                                    event.preventDefault();
                                    this.props.changeStory(event)
                                }}>
                                    <Icon16TruckOutline width={60} height={60}/>
                                    <p className="main-page-button_text" style={{fontSize: '16px'}}>Приемка товаров</p>
                                    <div className="main-page-button_cart-counter"></div>
                                </div>}

                            {current_user['meta']['settings'] && current_user['meta']['settings']['facing_monitoring'] == '1' &&
                                <div key="goFacingMonitoring" className="main-page-button orange" href="#"
                                     data-story="facing_monitoring_story" onClick={(event) => {
                                    event.preventDefault();
                                    this.props.changeStory(event)
                                }}>
                                    <Icon28WindowCheck width={60} height={60}/>
                                    <p className="main-page-button_text" style={{fontSize: '16px'}}>Инвентаризация
                                        витрины</p>

                                </div>}

                            <Div>
                                <MiniInfoCell key="cmdOldInterface"
                                              before={<Icon20Info/>}
                                              mode="more"
                                              onClick={() => this.setInterface(0)}

                                >
                                    Старый интерфейс
                                </MiniInfoCell>
                            </Div>

                            <Div>

                                <MiniInfoCell key="cmdTheme"
                                              before={current_theme === 'dark' ? <Icon20SunOutline/> :
                                                  <Icon20MoonOutline/>}
                                              mode="more"
                                              onClick={() => this.toggleTheme()}

                                >
                                    {current_theme === 'dark' ? 'Светлая тема' : 'Темная тема'}
                                </MiniInfoCell>
                            </Div>
                            {/*current_user['meta']['settings'] && current_user['meta']['settings']['firm_fit_club']
                                &&*/
                                current_user['default_klient']
                                && current_user['default_klient']['meta']
                                && current_user['default_klient']['meta']['Менеджер']
                                && current_user['default_klient']['meta']['Менеджер']['ФИО'] &&
                                <div key="managerInfo" className="main-page_manage-info ">
                                    <div className="manage-info-flex">
                                        <p className="my-manage">Ваш менеджер</p>
                                        <p className="name-manage">{current_user['default_klient']['meta']['Менеджер']['ФИО'] ? current_user['default_klient']['meta']['Менеджер']['ФИО'] : 'Не задано в 1С'}</p>
                                        <p className="email-manage">
                                            <Icon20PhoneOutline/>&nbsp;
                                            <a href={"tel:+" + current_user['default_klient']['meta']['Менеджер']['Телефон'].toString().replace('-', '').replace(' ', '')}>
                                                {current_user['default_klient']['meta']['Менеджер']['Телефон'] ? "+" + current_user['default_klient']['meta']['Менеджер']['Телефон'] : 'Не задано в 1С'}</a>
                                        </p>
                                        <p className="email-manage">
                                            <Icon20MailOutline/>&nbsp;
                                            <a target="_blank"
                                               href={"mailto:" + current_user['default_klient']['meta']['Менеджер']['email']}>
                                                {current_user['default_klient']['meta']['Менеджер']['email'] ? current_user['default_klient']['meta']['Менеджер']['email'] : 'Не задано в 1С'}
                                            </a>
                                        </p>

                                    </div>
                                </div>}

                            {current_user.manager_primavera && current_user.manager_primavera.map(el => {
                                if (!el.meta.manager) return
                                const {manager} = el.meta

                                return <div key="managerInfo" className="main-page_manage-info ">
                                    <div className="manage-info-flex">
                                        <p className="my-manage">Ваш менеджер Primavera Club</p>
                                        <p className="name-manage">{`${manager.name} ${manager.lastname} `}</p>
                                        <p className="email-manage">
                                            <Icon20PhoneOutline/>&nbsp;
                                            <a href={"tel:+" + manager.phone.toString().replace('-', '').replace(' ', '')}>
                                                {manager.phone ? "+" + manager.phone : 'Не задано в 1С'}</a>
                                        </p>
                                        <p className="email-manage">
                                            <Icon20MailOutline/>&nbsp;
                                            <a target="_blank"
                                               href={"mailto:" + manager.email}>
                                                {manager.email ? manager.email : 'Не задано в 1С'}
                                            </a>
                                        </p>

                                    </div>
                                </div>
                            })
                            }

                        </div>
                        <Div>
                            <NewsList
                                base_url={this.props.base_url}
                                embedded
                                current_user={this.props.current_user}
                            />
                        </Div>
                        <Div>

                            <MiniInfoCell key="cmdHelp"
                                          before={<Icon20QuestionOutline/>}
                                          mode="more"
                                          data-story="help_story"
                                          onClick={(e) => this.props.changeStory(e)}

                            >
                                Руководство пользователя
                            </MiniInfoCell>
                            <MiniInfoCell key="cmdHelp"
                                          before={<Icon20QuestionOutline/>}
                                          mode="more"
                                          data-story="help_story"
                                          onClick={(e) => this.setActiveModal(constants.MODAL_LIST_OBJECTS)}

                            >
                                Обращение в тех.поддержку
                            </MiniInfoCell>

                        </Div>
                    </Group>
                </SplitCol>
            </SplitLayout>

        );
    }


    setInterface = (number) => {
        const {cookies} = this.props;
        cookies.set('reactcatalog', number, {domain: 'scladro.ru', path: '/'})
        console.log(window.location.href)
        // return

        window.location.reload()

    }

    toggleTheme = () => {
        const newTheme = current_theme === 'light' ? 'dark' : 'light'

        localStorage.setItem(constants.current_theme_key, newTheme)
        window.location.reload()
    }
}

export default withCookies(Default);
